import React from 'react';
import '../../../../assets/css/Modal.css'

import {
    Modal,
} from 'react-bootstrap';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as FileSaver from 'file-saver';import * as XLSX from "xlsx";

class ModalExportUploadCustomerError extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            listCustomerError: [],
            reason: '',
            showBlock: true,
            signupInfo: null
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps, nextContext){
        if (nextProps.show){
            this.setState ({
                listCustomerError: nextProps.listCustomerError,
            });
        }
    }
    downloadFile = () => {
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.xlsx';
        let fileName = "SAS_Loi_Khach_Hang.xlsx"
        let newData = this.state.listCustomerError.map(item => {
            return {
                "Tên con": item.fullName,
                "Ngày sinh": item.birthday,
                "SĐT": item.phone,
                "Tên cha/mẹ": item.parentsName,
                "Giới tính": item.gender === "MALE"?"Nam": item.gender === "FEMALE"?"Nữ": "Khác",
                "Mã lỗi": item.errorMessage,
            };
        });

        const ws = XLSX.utils.json_to_sheet(newData);
        const wb = { Sheets: { 'Dữ liệu lỗi': ws }, SheetNames: ['Dữ liệu lỗi'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], {type: fileType});
        FileSaver.saveAs(data, fileName + fileExtension);
    }


    render() {
        const modalProp = {
            show: this.props.show,
            onHideModal: this.props.onHide,
            keyboard: false,
            backdrop: 'static',
        };
        return (
            <div>
                <Modal {...modalProp} dialogClassName="modal-dialog-centered">
                    <div className="modal-container">
                        <div className="btn-close">
                            <button type="button" className="close" onClick={this.props.onHide}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <Modal.Body>

                        <div>
                            <h1 className="text-center" style={{fontSize: 20,}}><b>Danh sách dữ liệu lỗi!</b></h1>
                        </div>

                        <div className='d-flex justify-content-center mt-3 mb-3'>
                            <label className='font-size-content'>Có {this.state.listCustomerError.length} dữ liệu Import lỗi.</label>
                        </div>

                        <div className="d-flex align-right col-md-12 col-xs-12 row">
                            <div className="d-flex justify-content-center align-center mt-3 mb-2 col-md-12 col-xs-12">
                                <button
                                    style={{minWidth: "fit-content", marginRight: "10px"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s background-btn w-50 type-button-fix btn btn-primary"
                                    onClick={() => this.downloadFile()}
                                >
                                        <span className='justify-content-center'>
                                            Tải file
                                        </span>
                                </button>
                                <button
                                    style={{minWidth: "fit-content"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s w-50 type-button-fix btn btn-secondary"
                                    onClick={this.props.onHide}
                                >
                                        <span className=''>
                                            Hủy
                                        </span>
                                </button>
                            </div>
                        </div>

                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

export  default  ModalExportUploadCustomerError
